/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=6b0ca6d4&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=ts&"
export * from "./table-list.vue?vue&type=script&lang=ts&"
import style0 from "./table-list.vue?vue&type=style&index=0&id=6b0ca6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ca6d4",
  null
  
)

export default component.exports